/**
 * Snake_case ↔ camelCase key transformation utilities.
 *
 * Used by both the admin API client and portal fetch helpers to normalise
 * backend snake_case responses into the camelCase types the frontend expects.
 */

/** Convert a single snake_case string to camelCase. */
function snakeToCamel(str: string): string {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

/**
 * Recursively transform object keys from snake_case to camelCase.
 * Handles nested objects and arrays.
 */
export function transformKeysToCamelCase<T>(obj: unknown): T {
  if (obj === null || obj === undefined) {
    return obj as T;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => transformKeysToCamelCase(item)) as T;
  }

  if (typeof obj === 'object') {
    const transformed: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(obj)) {
      const camelKey = snakeToCamel(key);
      transformed[camelKey] = transformKeysToCamelCase(value);
    }
    return transformed as T;
  }

  return obj as T;
}
